import { IP_MARKETPLACE_LIST_REQUEST } from "./constants";

export const ipMarketplaceListRequest = () => {
  return {
    type: IP_MARKETPLACE_LIST_REQUEST,
  };
};
